<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kH9AP7/tc-custom/9781488036996.jpg?1726574202291" alt="This image is the cover for the book Stonebrook Cottage, The Carriage House"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stonebrook Cottage, The Carriage House
      </h1>
      <p class="bookDescription body article font2">
        <b>A Texas Ranger and a Connecticut lawyer are on the trail of a vicious killer in the <i>New York Times</i>–bestselling author’s romantic suspense.</b><br/><br/>After building a career as a defense attorney in New England, Kara Galway has moved back to Texas in search of peace. But her thoughts return to the east coast when her friend and mentor, Connecticut Governor Mike Parisi, is murdered. And the danger is far from over. As soon as Kara’s friend Allyson is sworn in as the new governor, she and her family are targeted with mysterious threats.<br/><br/>Now Kara is on her way back to Connecticut, returning to a dangerous world of political corruption, determined to catch a killer. But she’s not alone. Texas Ranger Sam Temple is on her trail. And while Kara never asked for his help, he’s equally determined to keep her safe.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carla Neggers
      </h2>
      
      <p class="authorDescription body article">Carla Neggers is the&#160;<I>New York Times</I> bestselling author of the Sharpe and Donovan series featuring Boston-based FBI agents Emma Sharpe and Colin Donovan and the Swift River Valley series set in small-town New England. With many bestsellers to her credit, Carla and her husband divide their time between their hilltop home in Vermont, their kids&#39; places in Boston and various inns, hotels and hideaways on their travels, frequently to Ireland. Learn more at CarlaNeggers.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?daae1002